export const POLICY_FILES = {
  privacy: {
    title: "隐私政策",
    url: process.env.VUE_APP_PRIVACY_POLICY_URL || "/legal/privacy.html",
  },
  terms: {
    title: "服务条款",
    url: process.env.VUE_APP_TERMS_URL || "/legal/terms.html",
  },
};

export function getPolicyFile(type, siteConfig = {}) {
  const fallback = POLICY_FILES[type];
  if (!fallback) return null;

  const configUrl = type === "privacy" ? siteConfig.privacyPolicyUrl : siteConfig.termsUrl;

  return {
    title: fallback.title,
    url: configUrl || fallback.url,
  };
}
